import { render } from "./ModalProdSelection.vue?vue&type=template&id=4825b11c&scoped=true"
import script from "./ModalProdSelection.vue?vue&type=script&lang=js"
export * from "./ModalProdSelection.vue?vue&type=script&lang=js"

import "./ModalProdSelection.vue?vue&type=style&index=0&id=4825b11c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4825b11c"]])

export default __exports__